import {
  ContentBlock,
  Heading,
  Columns,
  Column,
  Box,
  Stack,
  Strong,
} from 'braid-design-system';
import type React from 'react';

import image from '../../images/culture.jpg';

import * as styles from './BringAllOpportunities.css';

interface Props {
  title: string;
  children: React.ReactNode;
}

export const BringAllOpportunities = ({ title, children }: Props) => (
  <Box background="customDark" style={{ backgroundColor: '#35BCC2' }}>
    <ContentBlock>
      <Box
        position="relative"
        paddingX={{ mobile: 'small', desktop: 'none' }}
        paddingY={['xlarge', 'xlarge']}
        background="customDark"
      >
        <Box
          style={{ position: 'relative', bottom: '15px', textWrap: 'balance' }}
        >
          <Columns collapseBelow="tablet" space="large" alignY="center">
            <Column width="1/2">
              <Stack space="xlarge">
                <Heading level="2">
                  <Strong>{title}</Strong>
                </Heading>
                <Box>{children}</Box>
              </Stack>
            </Column>
            <Column width="1/2">
              <Box
                className={styles.Image}
                boxShadow="small"
                style={{ backgroundImage: `url(${image})` }}
              />
            </Column>
          </Columns>
        </Box>
      </Box>
    </ContentBlock>
  </Box>
);
